<script lang="ts" setup>
  const { organizations } = useUserStore();
  const { organizationUrl, isOrganizationAdmin } =
    useOrganizationStore();
</script>

<template>
  <div class="min-w-xs space-y-3 p-4 sm:min-w-sm md:min-w-md">
    <div class="flex items-center justify-between">
      <span class="font-medium sm:text-lg">
        {{ $t("labels.organizations") }}
      </span>
      <UButton
        variant="ghost"
        class="underline"
        v-if="isOrganizationAdmin"
      >
        <span>
          {{ $t("actions.manage") }}
          <span class="sr-only">
            {{ $t("labels.organization") }}</span
          >
        </span>
      </UButton>
    </div>
    <div
      v-for="organization in organizations"
      :key="organization.organizationId"
      class="px-2.5"
      :class="{
        'border-primary-500 border-l-4':
          organization.organizationUrl == organizationUrl,
      }"
    >
      <UButton
        class="block p-2 font-medium text-gray-900 capitalize"
        variant="link"
        :class="{
          'border-primary-500 bg-primary-50 rounded-lg border-[1.5px]':
            organization.organizationUrl == organizationUrl,
        }"
        :to="`/${organization.organizationUrl}`"
        external
      >
        {{ organization.organizationTitle }}
      </UButton>
    </div>
  </div>
</template>

<style></style>
